import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import IPLPTemplateList from './IPLPTemplateList';
import { IplpTemplate } from '../../../../../graphql/graphql';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	onItemSelect: (item: IplpTemplate) => void;
}

const IPLPTemplateListModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.IPLPTemplateListModal.title'
			size={Size.FULLSCREEN}
			contentScroll={false}
			contentStyle={{ height: '100%', overflow: 'hidden' }}>
			<IPLPTemplateList onItemSelect={props.onItemSelect} />
		</BaseModal>
	);
};

export default IPLPTemplateListModal;
